import { env } from 'Framework/env';

const Consts = {
  env: env,
};

export default Consts;
